import { IAssignmentModel } from '@/components/interfaces/Assignment';
import { LABEL_MAP, SECTION_REGEX } from './variables';

export function getColumnName(assignmentModel: IAssignmentModel) {
  const match = (assignmentModel.section_full_title || '').match(SECTION_REGEX);

  if (!match) return assignmentModel.section_full_title || assignmentModel.label;

  const sectionWithNumber = match[0];

  return `${sectionWithNumber} - ${LABEL_MAP[assignmentModel.assignment_type]}`;
}
